module.exports = __webpack_public_path__ + "img/trial1-3.b11062b1.png";